/* ============================================================
   cb-color-guide.js - LEGO-kleurengids (redesign 2026)

   Hoort bij sections/cb-color-guide.liquid.

   De kleuren komen uit window.CB_LEGO_COLORS (naam naar hex) en
   window.CB_LEGO_COLOR_META (naam naar BrickLink-nummer en groep).
   Allebei worden ze gezet door snippets/cb-lego-colors.liquid, het
   palet dat ook de swatches op de productpagina tekent. Er staat hier
   dus geen tweede kleurenlijst; dat was juist het probleem met de
   oude pagina.

   Alle zichtbare tekst komt uit de sectie mee in een JSON-blok, zodat
   dit bestand taalvrij blijft.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-cb-cg]');
  if (!root) return;

  var palette = window.CB_LEGO_COLORS || {};
  var meta = window.CB_LEGO_COLOR_META || {};

  var strings = {};
  var stringNode = root.querySelector('[data-cb-cg-strings]');
  if (stringNode) {
    try {
      strings = JSON.parse(stringNode.textContent);
    } catch (e) {
      strings = {};
    }
  }

  var partsUrl = root.getAttribute('data-parts-url') || '/collections/all-parts';
  var filterKey = root.getAttribute('data-filter-key') || 'filter.p.m.custom.color';

  /* ---- De kleuren als lijst ---- */

  /* Alleen kleuren met een nummer: het palet bevat ook andere schrijfwijzen
     (Trans-Brown, Blue Violet) die alleen voor swatches bedoeld zijn. */
  var colors = Object.keys(palette).filter(function (name) {
    return meta[name];
  }).map(function (name) {
    var hex = palette[name];
    var extra = meta[name] || {};
    return {
      name: name,
      hex: hex,
      id: extra.id || '',
      group: extra.group || 'basis',
      trans: name.indexOf('Trans-') === 0,
      rgb: toRgb(hex)
    };
  });

  function toRgb(hex) {
    var n = parseInt(String(hex).replace('#', ''), 16);
    if (isNaN(n)) return '';
    return ((n >> 16) & 255) + ', ' + ((n >> 8) & 255) + ', ' + (n & 255);
  }

  /* Lichte kleuren krijgen een randje, anders valt wit weg tegen de kaart. */
  function isLight(hex) {
    var n = parseInt(String(hex).replace('#', ''), 16);
    if (isNaN(n)) return false;
    var r = (n >> 16) & 255;
    var g = (n >> 8) & 255;
    var b = n & 255;
    return 0.299 * r + 0.587 * g + 0.114 * b > 200;
  }

  /* Transparante kleuren staan op een ruitjespatroon, zoals in een
     beeldbewerker: anders is Trans-Clear een wit vlak. */
  function swatchStyle(color) {
    if (color.trans) {
      return (
        'background-image: linear-gradient(' +
        color.hex +
        'dd, ' +
        color.hex +
        'dd), repeating-conic-gradient(#e6e6e6 0% 25%, #ffffff 0% 50%);' +
        'background-size: auto, 12px 12px;'
      );
    }
    var style = 'background-color: ' + color.hex + ';';
    if (isLight(color.hex)) {
      style += 'box-shadow: inset 0 0 0 1px rgba(0,0,0,0.09);';
    }
    return style;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function label(color) {
    var parts = [color.name];
    if (color.id) parts.push(strings.id + ' ' + color.id);
    parts.push(color.hex);
    return parts.join(' · ');
  }

  /* ---- Stand van zaken ---- */

  var state = { q: '', view: 'grid', sort: 'name', group: 'alle', transOnly: false };

  var listNode = root.querySelector('[data-cb-cg-list]');
  var emptyNode = root.querySelector('[data-cb-cg-empty]');
  var shownNodes = root.querySelectorAll('[data-cb-cg-shown]');
  var totalNodes = root.querySelectorAll('[data-cb-cg-total]');
  var totalPill = root.querySelector('[data-cb-cg-total-pill]');

  function matches(color) {
    if (state.transOnly && !color.trans) return false;
    if (state.group !== 'alle' && color.group !== state.group) return false;
    if (!state.q) return true;
    var q = state.q.toLowerCase();
    return (
      color.name.toLowerCase().indexOf(q) !== -1 ||
      String(color.id).indexOf(q) !== -1 ||
      color.hex.toLowerCase().indexOf(q) !== -1
    );
  }

  function sorted(list) {
    var copy = list.slice();
    if (state.sort === 'id') {
      copy.sort(function (a, b) {
        return (parseInt(a.id, 10) || 9999) - (parseInt(b.id, 10) || 9999);
      });
    } else {
      copy.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
    return copy;
  }

  function cardHtml(color) {
    return (
      '<button class="cb-cg__card" type="button" data-cb-cg-open="' +
      escapeHtml(color.name) +
      '" aria-label="' +
      escapeHtml(label(color)) +
      '">' +
      '<span class="cb-cg__swatch" style="' +
      swatchStyle(color) +
      '"><span class="cb-cg__stud"></span><span class="cb-cg__stud"></span></span>' +
      '<span class="cb-cg__card-body">' +
      '<span class="cb-cg__card-name">' +
      escapeHtml(color.name) +
      '</span>' +
      '<span class="cb-cg__card-meta">' +
      (color.id ? '<span>' + escapeHtml(strings.id + ' ' + color.id) + '</span>' : '<span></span>') +
      '<span class="cb-cg__hex">' +
      escapeHtml(color.hex) +
      '</span></span></span></button>'
    );
  }

  function rowHtml(color) {
    return (
      '<button class="cb-cg__row" type="button" data-cb-cg-open="' +
      escapeHtml(color.name) +
      '" aria-label="' +
      escapeHtml(label(color)) +
      '">' +
      '<span class="cb-cg__row-swatch" style="' +
      swatchStyle(color) +
      '"></span>' +
      '<span class="cb-cg__row-name">' +
      escapeHtml(color.name) +
      '<span class="cb-cg__row-rgb">RGB ' +
      escapeHtml(color.rgb) +
      '</span></span>' +
      '<span class="cb-cg__row-id">' +
      escapeHtml(color.id ? String(color.id) : '') +
      '</span>' +
      '<span class="cb-cg__row-hex cb-cg__mono">' +
      escapeHtml(color.hex) +
      '</span>' +
      '<span class="cb-cg__type' +
      (color.trans ? ' cb-cg__type--trans' : '') +
      '">' +
      escapeHtml(color.trans ? strings.trans : strings.solid) +
      '</span></button>'
    );
  }

  function tileHtml(color) {
    return (
      '<button class="cb-cg__tile-swatch" type="button" data-cb-cg-open="' +
      escapeHtml(color.name) +
      '" title="' +
      escapeHtml(label(color)) +
      '" aria-label="' +
      escapeHtml(label(color)) +
      '" style="' +
      swatchStyle(color) +
      '"></button>'
    );
  }

  function headerHtml() {
    return (
      '<div class="cb-cg__row cb-cg__row--head" aria-hidden="true">' +
      '<span></span><span>' +
      escapeHtml(strings.colName) +
      '</span><span>' +
      escapeHtml(strings.id) +
      '</span><span>' +
      escapeHtml(strings.colHex) +
      '</span><span>' +
      escapeHtml(strings.colType) +
      '</span></div>'
    );
  }

  function render() {
    var results = sorted(colors.filter(matches));

    listNode.setAttribute('data-view', state.view);

    if (!results.length) {
      listNode.innerHTML = '';
      emptyNode.hidden = false;
    } else {
      emptyNode.hidden = true;
      var html = '';
      if (state.view === 'grid') {
        html = results.map(cardHtml).join('');
      } else if (state.view === 'list') {
        html = headerHtml() + results.map(rowHtml).join('');
      } else {
        html = results.map(tileHtml).join('');
      }
      listNode.innerHTML = html;
    }

    Array.prototype.forEach.call(shownNodes, function (node) {
      node.textContent = results.length;
    });
    Array.prototype.forEach.call(totalNodes, function (node) {
      node.textContent = colors.length;
    });
    if (totalPill) totalPill.hidden = false;
  }

  /* ---- Bediening ---- */

  var search = root.querySelector('[data-cb-cg-search]');
  if (search) {
    search.addEventListener('input', function () {
      state.q = search.value.trim();
      render();
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-cg-view]'), function (button) {
    button.addEventListener('click', function () {
      state.view = button.getAttribute('data-cb-cg-view');
      Array.prototype.forEach.call(root.querySelectorAll('[data-cb-cg-view]'), function (other) {
        other.setAttribute('aria-selected', other === button ? 'true' : 'false');
      });
      render();
    });
  });

  var sortSelect = root.querySelector('[data-cb-cg-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      render();
    });
  }

  var transToggle = root.querySelector('[data-cb-cg-trans]');

  function setGroup(code) {
    state.group = code;
    Array.prototype.forEach.call(root.querySelectorAll('[data-cb-cg-group]'), function (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('data-cb-cg-group') === code ? 'true' : 'false');
    });
    /* De groep "transparant" en de schakelaar zeggen hetzelfde; ze horen dus
       niet uit elkaar te lopen. */
    if (transToggle) {
      transToggle.checked = code === 'trans';
      state.transOnly = transToggle.checked;
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-cg-group]'), function (chip) {
    chip.addEventListener('click', function () {
      setGroup(chip.getAttribute('data-cb-cg-group'));
      render();
    });
  });

  if (transToggle) {
    transToggle.addEventListener('change', function () {
      state.transOnly = transToggle.checked;
      render();
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-cg-clear]'), function (button) {
    button.addEventListener('click', function () {
      state.q = '';
      if (search) search.value = '';
      setGroup('alle');
      if (transToggle) {
        transToggle.checked = false;
        state.transOnly = false;
      }
      render();
    });
  });

  /* ---- Detailvenster ---- */

  var modal = root.querySelector('[data-cb-cg-modal]');
  var lastTrigger = null;

  function byName(name) {
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].name === name) return colors[i];
    }
    return null;
  }

  function openModal(color, trigger) {
    if (!modal || !color) return;
    lastTrigger = trigger || null;

    modal.querySelector('[data-cb-cg-modal-swatch]').setAttribute('style', swatchStyle(color));
    modal.querySelector('[data-cb-cg-modal-name]').textContent = color.name;
    modal.querySelector('[data-cb-cg-modal-id]').textContent = color.id || '-';
    modal.querySelector('[data-cb-cg-modal-hex]').textContent = color.hex;
    modal.querySelector('[data-cb-cg-modal-rgb]').textContent = color.rgb;

    var type = modal.querySelector('[data-cb-cg-modal-type]');
    type.textContent = color.trans ? strings.trans : strings.solid;
    type.className = 'cb-cg__type' + (color.trans ? ' cb-cg__type--trans' : '');

    var link = modal.querySelector('[data-cb-cg-modal-link]');
    link.textContent = strings.partsIn + ' ' + color.name;
    link.setAttribute('href', partsUrl + '?' + filterKey + '=' + encodeURIComponent(color.name));

    var copy = modal.querySelector('[data-cb-cg-copy]');
    copy.textContent = copy.getAttribute('data-label');
    copy.setAttribute('data-hex', color.hex);

    modal.hidden = false;
    document.addEventListener('keydown', onKey);
    copy.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.removeEventListener('keydown', onKey);
    if (lastTrigger) lastTrigger.focus();
  }

  function onKey(event) {
    if (event.key === 'Escape') closeModal();
  }

  listNode.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cb-cg-open]');
    if (!trigger) return;
    openModal(byName(trigger.getAttribute('data-cb-cg-open')), trigger);
  });

  if (modal) {
    Array.prototype.forEach.call(modal.querySelectorAll('[data-cb-cg-close]'), function (button) {
      button.addEventListener('click', closeModal);
    });

    var copyButton = modal.querySelector('[data-cb-cg-copy]');
    copyButton.addEventListener('click', function () {
      var hex = copyButton.getAttribute('data-hex') || '';
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(hex).then(function () {
        copyButton.textContent = copyButton.getAttribute('data-label-done');
        setTimeout(function () {
          copyButton.textContent = copyButton.getAttribute('data-label');
        }, 2000);
      });
    });
  }

  render();
})();
